<template>
    <o-table :title="$t('sandoz.buying_groups')" ref="tableList" url="/api/buying_groups">
        <template slot="filter">
            <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                <o-filter-text :title="$t('sandoz.buying_group')" column="buying_group"
                               :prepend-percentage="true"></o-filter-text>
                <o-filter-text :title="$t('sandoz.buying_group_code')" column="buying_group_code"
                               :prepend-percentage="true"></o-filter-text>
                <o-filter-select :items="yesNo" :title="$t('sandoz.chargeback_allowed')"
                                 column="chargeback_allowed" value-field="value"
                                 text-field="text"></o-filter-select>
                <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"
                               :prepend-percentage="true"></o-filter-text>
            </o-filter>
        </template>
        <template slot="head">
            <o-table-header column="buying_group">{{$t('sandoz.buying_group')}}</o-table-header>
            <o-table-header column="chargeback_allowed">{{$t('sandoz.chargeback_allowed')}}</o-table-header>
            <o-table-header column="customer_external_id">{{$t('sandoz.customer_external_id')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>{{ props.item.buying_group }}</td>
            <td>{{ props.item.chargeback_allowed ? $t('sandoz.yes') : $t('sandoz.no') }}</td>
            <td>{{ props.item.customer_external_id }}</td>
        </template>
    </o-table>
</template>

<script>
export default {
  data: () => ({
    yesNo: []
  }),
  created() {
    this.yesNo = [
      {value: 1, text: this.$i18n.t('sandoz.yes')},
      {value: 0, text: this.$i18n.t('sandoz.no')}
    ]
  }
}
</script>
